import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PainelinsumoService } from '../../../services/painelinsumo.service';
import { ToastService } from '../../../services/toast.service';
import { DepositoInsumoPosicao } from '../../../types/DepositoInsumoPosicao.type';

@Component({
  selector: 'app-posicao-dialog',
  templateUrl: './posicao-dialog.component.html',
  styleUrl: './posicao-dialog.component.css'
})
export class PosicaoDialogComponent {
  @Input() visivel: boolean = false;
  @Input() deposito: string = "";
  @Output() public fechar = new EventEmitter();

  posicao: DepositoInsumoPosicao = {} as DepositoInsumoPosicao

  posicaoEnviada: Boolean = false;

  constructor(private painelService: PainelinsumoService, private toastService: ToastService) {}

  escondeDialog() {
    this.visivel = false;
    this.posicao = {} as DepositoInsumoPosicao;
    this.posicaoEnviada = false;

    this.fechar.emit();
  }

  salvar() {
    this.posicaoEnviada = true;

    if (this.posicao.cdPosicao?.trim() && this.posicao.dePosicao?.trim()) {
      this.posicao.idDeposito = this.deposito;
      
      this.painelService.postPosicao(this.posicao).subscribe({
        next: () => {
          this.toastService.sucesso("Sucesso", "Posição salva com sucesso");
          this.escondeDialog();
        },
        error: (value) => {
          this.toastService.erro("Erro", "Erro ao salvar a posição: " + value.error);
        }
      })
    }
  }

}
